import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

// 上司向け: 部下の打刻忘れ一覧。
// スケジュール上の出社/退社時刻を過ぎても打刻が無い部下を表示。
// 部下が打刻するとライブ判定で次回更新時に自動的に一覧から外れる（60秒ごとに自動更新）。
export default function SupervisorForgotPunchList() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(true);
  const timerRef = useRef(null);

  const fetchItems = useCallback(async () => {
    try {
      const res = await api.get('/api/employee/subordinate-forgot-punch/');
      setItems(Array.isArray(res.data?.items) ? res.data.items : []);
      setDate(res.data?.date || '');
    } catch (e) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchItems();
    // 部下が打刻したら自動的に消えるよう、60秒ごとに再取得
    timerRef.current = setInterval(fetchItems, 60000);
    return () => clearInterval(timerRef.current);
  }, [fetchItems]);

  const th = { background: '#1e3a5f', color: '#fff', padding: '8px 10px', fontSize: '0.82rem', whiteSpace: 'nowrap', border: '1px solid #2c4a73' };
  const td = { padding: '8px 10px', fontSize: '0.85rem', border: '1px solid #e2e8f0', whiteSpace: 'nowrap' };
  const btn = (bg) => ({ padding: '6px 12px', background: bg, color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: '0.8rem' });
  const kindBadge = (kind) => ({
    display: 'inline-block', padding: '2px 8px', borderRadius: 4, fontWeight: 700, fontSize: '0.78rem',
    color: kind === '出勤' ? '#991b1b' : '#9a3412',
    background: kind === '出勤' ? '#fecaca' : '#fed7aa',
  });

  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
        <h2 style={{ fontSize: '1.2rem', fontWeight: 700, margin: 0 }}>部下の打刻忘れ</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" onClick={fetchItems} disabled={loading} style={btn('#475569')}>更新</button>
          <button type="button" onClick={() => navigate(-1)} style={btn('#94a3b8')}>戻る</button>
        </div>
      </div>
      <p style={{ color: '#64748b', fontSize: '0.85rem', marginBottom: 14 }}>
        {date && `対象日: ${date}　`}スケジュールの予定時刻を過ぎても打刻が無い部下を表示します（打刻すると自動的に消えます）。
      </p>

      {loading ? (
        <p style={{ color: '#64748b' }}>読み込み中...</p>
      ) : items.length === 0 ? (
        <p style={{ color: '#16a34a' }}>🟢 打刻忘れの部下はいません。</p>
      ) : (
        <div style={{ overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 8 }}>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={th}>日付</th>
                <th style={th}>名前（コード）</th>
                <th style={th}>出勤又は退勤時間</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it, idx) => (
                <tr key={`${it.memberId}-${idx}`}>
                  <td style={td}>{it.date}</td>
                  <td style={td}>{it.name}（{it.memberId}）</td>
                  <td style={td}>
                    <span style={kindBadge(it.kind)}>{it.kind}</span>
                    <span style={{ marginLeft: 8 }}>{it.scheduleTime}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
